import config from "../../config"

export function waitForInit() {
	return new Promise((res, rej) => {
		const hasFbLoaded = () => {
			if (!window.FB) createScriptfb()
			if (window.FB) {
				res()
			} else {
				setTimeout(hasFbLoaded, 300)
			}
		}
		hasFbLoaded()
	})
}
function createScriptfb() {
	// load the sdk
	window.fbAsyncInit = fbAsyncInit
	const script = document.createElement("script")
	script.src = "https://connect.facebook.net/en_US/sdk.js"
	script.async = true
	script.onload = initFB
	document.body.appendChild(script)
}

function initFB() {}

function fbAsyncInit() {
	// init the fb sdk client
	const fb = window.FB
	fb.init({
		appId: config.auth.social.FB,
		status: true,
		cookie: true,
		xfbml: true,
		version: "v2.11"
	})
}

export function waitForGBInit() {
	return new Promise((res, rej) => {
		const hasGMLoaded = () => {
			const ga =
				window.gapi && window.gapi.auth2
					? window.gapi.auth2.getAuthInstance()
					: null
			if (!ga) createScript()
			if (window.gapi) {
			} else {
				setTimeout(hasGMLoaded, 300)
			}
		}
		hasGMLoaded()
	})
}

function createScript() {
	// load the Google SDK
	const script = document.createElement("script")
	script.src = "https://apis.google.com/js/platform.js"
	script.async = true
	script.onload = initGapi
	document.body.appendChild(script)
}

function initGapi() {
	// init the Google SDK client
	const g = window.gapi
	g.load("auth2", function () {
		g.auth2.init({
			client_id: config.auth.social.GM,
			// authorized scopes
			redirect_uri: "https://www.mixedmodel.academy/",
			scope: "profile email openid"
		})
	})
}
